import axios from 'axios';

export default class EventService {
    /**
     * Get an event.
     *
     * @param {String} code
     * @param {String|null} zone
     * @return {AxiosPromise<any>}
     */
    static get(code, zone = null) {
        let params = '';
        if (zone) {
            params = '?zone=' + zone;
        }
        return axios.get(this.endpoint() + '/' + code + params);
    }

    /**
     * Get endpoint of API.
     *
     * @return {string}
     */
    static endpoint() {
        return 'events';
    }
}
